import { css } from '@emotion/react'
import Link from 'next/link'
import React from 'react'
import { addNewsPicksTrackingParam } from '@/lib/url'
import { ContentfulNpStartupStaticBanner } from '../../../types'

type Props = {
  staticBanner: ContentfulNpStartupStaticBanner | null
  trackingId: string
}

export const NewsPicksStaticBanner: React.VFC<Props> = (props) => {
  return (
    <>
      {props.staticBanner && (
        <Link
          href={addNewsPicksTrackingParam(
            props.staticBanner.articleUrl,
            props.staticBanner.newsId
          )}
          passHref
        >
          <a
            id={props.trackingId}
            className="np-static-image-banner"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div
              css={css`
                position: relative;
                width: 1200px;
                height: 150px;
                max-width: 100%;
                &:after {
                  position: absolute;
                  display: block;
                  content: '';
                  top: 0;
                  left: 0;
                  height: 100%;
                  width: 100%;
                  background-color: transparent;
                  opacity: 0.08;
                  transition: background-color 0.2s ease;
                }
                &:hover:after {
                  background-color: #000000;
                  transition: background-color 0.2s ease;
                }
              `}
            >
              <img
                alt="NewsPicks banner image"
                src={props.staticBanner.articleBannerImageUrl}
                width="1200"
                height="150"
                css={css`
                  vertical-align: bottom;
                `}
              />
            </div>
          </a>
        </Link>
      )}
    </>
  )
}
